import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Box, Grid, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../components/Loading';
import { storeToken } from '../redux/TokenSlice';
import { SchoolHome } from './SchoolHome';
import { TeacherHome } from './TeacherHome';
import logo from '../assets/airTeachr-Logo.png';
import { Link, Link as RouterNavLink } from 'react-router-dom';
const GridShift = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        background: '#fff',
        padding: '10px 0',
    },
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));
const BoxShift = styled(Box)(({ theme }) => ({
    minHeight: '43px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
        marginLeft: '2rem',
    },
    [theme.breakpoints.down('md')]: {
        textAlign: 'center',
        // position: 'absolute',
        // left: '50%',
        // transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
    },
}));
const ImgLogo = styled('img')(({ theme }) => ({
    // maxHeight: '60px',
    width: '100%',
    height: '60px',
    textAlign: 'center',
    marginLeft: '10px',
    [theme.breakpoints.up('md')]: {
        padding: '5px',
        margin: '5px 8px 10px 8px',
    },
    [theme.breakpoints.down('md')]: {
        height: '50px',
        width: '212px',
    },
    [theme.breakpoints.only('xs')]: {
        height: '35px',
        width: '148px',
    },
}));
export const HomePage = () => {
    const [state, setState] = useState({
        username: '',
        profile: {},
        ackronym: '',
        type: '',
    });

    const dispatch = useDispatch();
    const { loginWithRedirect, getAccessTokenSilently } = useAuth0();

    const profile = useSelector(state => state.profile.profile);
    const token = useSelector(state => state.token.token);

    useEffect(() => {
        if (profile.Data.Count > 0) {
            console.log('Profile Itmes', JSON.stringify(profile.Data.Items));
            setState({
                username: profile.Data.Items[0].firstName,
                ackronym:
                    profile.Data.Items[0].firstName.charAt(0) +
                    profile.Data.Items[0].lastName.charAt(0),
                type: profile.Data.Items[0].type,
            });
            console.log(
                'token permissions ' + JSON.stringify(token.permissions)
            );
            const getNewToken = async () => {
                try {
                    console.log('Trying to log user in');
                    const token = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                    });
                    dispatch(storeToken(token));
                } catch (e) {
                    //catch block created as this is required for Google auth login to work. It was not in the documentation
                    //but was found later as required
                    console.log('Error being caused', JSON.stringify(e));
                    if (e.error === 'login_required') {
                        loginWithRedirect();
                    }
                    if (e.error === 'consent_required') {
                        loginWithRedirect();
                    }
                    throw e;
                }
            };
            getNewToken();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile.Data.Count, profile.Data.Items]);

    // set user type
    const isTeacher = state.type;
    const isSchool = state.type;

    // log results
    console.log('Profile type for Home Page: ' + state.type);

    return (
        // <Paper className="full" sx={{ p: 1 }}>
        <Box>
            <GridShift>
                <BoxShift>
                    {' '}
                    <Link tag={RouterNavLink} to="/" exact>
                        <ImgLogo src={logo} alt="airTeachr logo" />
                    </Link>
                </BoxShift>
            </GridShift>
            {isTeacher === 'Teacher' && <TeacherHome />}
            {isSchool === 'School' && <SchoolHome />}
        </Box>
        // </Paper>
    );
};

export default withAuthenticationRequired(HomePage, {
    onRedirecting: () => <Loading />,
});
